const NotificationTypes = {
  READ_NOTIFICATION: 'READ_NOTIFICATION',
  READ_NOTIFICATION_SUCCESS: 'READ_NOTIFICATION_SUCCESS',
  READ_NOTIFICATION_FAILURE: 'READ_NOTIFICATION_FAILURE',

  DELETE_NOTIFICATION: 'DELETE_NOTIFICATION',
  DELETE_NOTIFICATION_SUCCESS: 'DELETE_NOTIFICATION_SUCCESS',
  DELETE_NOTIFICATION_FAILURE: 'DELETE_NOTIFICATION_FAILURE',

  FETCH_NOTIFICATION: 'FETCH_NOTIFICATION',
  FETCH_NOTIFICATION_SUCCESS: 'FETCH_NOTIFICATION_SUCCESS',
  FETCH_NOTIFICATION_FAILURE: 'FETCH_NOTIFICATION_FAILURE',

  FETCH_MORE_NOTIFICATION: 'FETCH_MORE_NOTIFICATION',
  FETCH_MORE_NOTIFICATION_SUCCESS: 'FETCH_MORE_NOTIFICATION_SUCCESS',
  FETCH_MORE_NOTIFICATION_FAILURE: 'FETCH_MORE_NOTIFICATION_FAILURE',

  FETCH_NEW_NOTIFICATIONS: 'FETCH_NEW_NOTIFICATIONS',
  FETCH_NEW_NOTIFICATIONS_SUCCESS: 'FETCH_NEW_NOTIFICATIONS_SUCCESS',
  FETCH_NEW_NOTIFICATIONS_FAILURE: 'FETCH_NEW_NOTIFICATIONS_FAILURE',

  OPEN_NEW_NOTIFICATIONS: 'OPEN_NEW_NOTIFICATIONS',
  OPEN_NEW_NOTIFICATIONS_SUCCESS: 'OPEN_NEW_NOTIFICATIONS_SUCCESS',
  OPEN_NEW_NOTIFICATIONS_FAILURE: 'OPEN_NEW_NOTIFICATIONS_FAILURE',
};

export default NotificationTypes;
